<span
  class="tw-flex
  {{
    !isPrimary &&
      'tw-text-xs tw-font-medium tw-leading-[125%] tw-tracking-[0.005em] tw-text-dt-text-action'
  }}
  {{ isPrimary && 'tw-flex-col tw-tracking-[0.0125em] tw-text-dt-text-headings xs:tw-text-sm' }}
  "
>
  <ng-content></ng-content>
</span>
